/*
 * @Author: dali
 * @Date: 2022-08-29 10:00:32
 * @LastEditors: 陈威达
 * @LastEditTime: 2024-09-25 13:23:37
 * @FilePath: \gerlun-react-website\src\components\im\index.jsx
 * @Description:
 */
import React from 'react'
import styles from './im.scss'
import headset from '@/common/images/svgs/headset.svg'
import douyingImg from '@/common/images/icon/douyin2.png'
import douyingImg_x from '@/common/images/pageHome/bt-1.jpg'
import weixinImg from '@/common/images/icon/weixin2.png'
import weixinImg_x from '@/common/images/pageHome/bt-2.jpg'
import qiweiImg from '@/common/images/pageHome/qw.jpg'
import { openIM } from '@/utils/im'
export default function Im() {
  return (
    <>
      <div className={`${styles['cust-im']}`}>
        <div className={`${styles['im-qiwei']}`} onClick={() => openIM()}>
          <div className={`${styles['im-icon-content']}`}>
            <img src={headset} alt='headset' className={styles['img-icon']}/>
          </div>
          <div className={`${styles['im-text']}`}>
            <span>在线</span>
            <span>咨询</span>
          </div>
        </div>
        <div className={`${styles['im-weixin']}`}>
          <img src={weixinImg} alt='weixinImg' className={styles['img-icon']}/>
          <p>微信</p>
          <div className={`${styles['im-triangle']}`}>
            <div className='img-wrap'>
              <img src={weixinImg_x} alt='weixinImg_x'/>
              <span>微信</span>
            </div>
            <div className='img-wrap'>
              <img src={qiweiImg} alt='qiweiImg'/>
              <span>企业微信</span>
            </div>
          </div>
        </div>
        <div className={`${styles['im-douyin']}`}>
          <img src={douyingImg} alt='douyingImg' className={styles['img-icon']}/>
          <p>抖音</p>
          <div className={`${styles['im-triangle_x']}`}><img src={douyingImg_x} alt='douyingImg_x'/></div>
        </div>
      </div>
    </>
  )
}
